import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

function CamperSolarMonitorApp() {
  const { t, lang } = useLang();
  const showsItems   = t("camperSolarMonitorApp.showsItems");
  const hardwareItems = t("camperSolarMonitorApp.hardwareItems");
  const screenshotSrc = `/images/camper-solar-app-${lang}.png`;

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">{t("camperSolarMonitorApp.label")}</span>
        <div className="subhead">{t("camperSolarMonitorApp.title")}</div>
        <p className="section-intro-inner">{t("camperSolarMonitorApp.intro")}</p>
      </div>

      <div className="showcase-layout">
        <div className="showcase-main">

          <div className="tool-card showcase-card">
            <h3>{t("camperSolarMonitorApp.overviewTitle")}</h3>
            <p>{t("camperSolarMonitorApp.overview1")}</p>
            <p>{t("camperSolarMonitorApp.overview2")}</p>
          </div>

          <div className="tool-card showcase-card">
            <h3>{t("camperSolarMonitorApp.showsTitle")}</h3>
            <ul className="showcase-list">
              {Array.isArray(showsItems) && showsItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="tool-card showcase-card">
            <h3>{t("camperSolarMonitorApp.hardwareTitle")}</h3>
            <ul className="showcase-list">
              {Array.isArray(hardwareItems) && hardwareItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>

        </div>

        <div className="showcase-sidebar">
          <div className="tool-card showcase-links-card">
            <div className="showcase-app-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="4"/>
                <line x1="12" y1="2" x2="12" y2="4"/>
                <line x1="12" y1="20" x2="12" y2="22"/>
                <line x1="4.93" y1="4.93" x2="6.34" y2="6.34"/>
                <line x1="17.66" y1="17.66" x2="19.07" y2="19.07"/>
                <line x1="2" y1="12" x2="4" y2="12"/>
                <line x1="20" y1="12" x2="22" y2="12"/>
                <line x1="4.93" y1="19.07" x2="6.34" y2="17.66"/>
                <line x1="17.66" y1="6.34" x2="19.07" y2="4.93"/>
              </svg>
            </div>
            <h3>{t("camperSolarMonitorApp.title")}</h3>
            <div className="project-tags" style={{marginBottom:"1.25rem"}}>
              <span className="tool-tag">iOS</span>
              <span className="tool-tag">Swift</span>
              <span className="tool-tag">BLE</span>
            </div>
            <div className="showcase-btn-col">
              <a href="https://apps.apple.com" target="_blank" rel="noreferrer" className="showcase-btn showcase-btn--primary">
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                {t("camperSolarMonitorApp.appStore")}
              </a>
              <Link to="/camper-solar-monitor-app/privacy" className="showcase-btn showcase-btn--outline">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                {t("camperSolarMonitorApp.privacyPolicy")}
              </Link>
            </div>
          </div>
          <div className="tool-card showcase-card">
            <div className="showcase-screenshot">
              <img src={screenshotSrc} alt={t("camperSolarMonitorApp.title")} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CamperSolarMonitorApp;
